<template>
	<div><p>Logging ..........................</p>
	<el-dialog
                  :visible.sync="pwdFalseShow"
                  width="27%"
                  class="errDia"
                  :before-close="handleClose"
                  title="hint"
                >
                  <div style=" text-align: center;">
                    <p>Your password does not meet relevant requirements,Please<router-link to="/ChangePassword" style="color:red;">click here</router-link>to change your password.</p>
                    
                  </div>
                </el-dialog>
				</div>
</template>
<script>
	let timer
export default {
	data(){
		return {
		timer: null ,// 定时器名称
		Openkind:"",
		openIds:"" ,
		accessToken1:"",
		pwdFalseShow:false
		}	
	},
	mounted() {
	timer = setInterval(this.qqLogin, 3000);
	},
	methods:{
		qqLogin(){
		if (QC.Login.check()) {//检查是否登录
			QC.Login.getMe((openId,accessToken)=>{//该处的openId，accessToken就是后台需要的参数了，后台通过这些参数拿取临时登录凭证，然后就是自己的逻辑了<br>          console.log("登录回调");
			this.openIds = openId;
		    var data = {
				  Openkind:"QQ",
				  openId: openId
				  }
				 this.$store.dispatch("_postThirdRegister",data).then(res => {
					 if (res.data.IsSuccess) {		
						 if(!res.data.Data.IsGo){
                    this.pwdFalseShow = true
                    return;
                    }			
					   sessionStorage.setItem("text",1);
					   localStorage.setItem("userInfo",JSON.stringify(res.data.Data));						 
					   var urldomain = window.apiHosts+"/author/#/";
					   window.location.href=urldomain;	
					   this.$message({
					             showClose: true,
					             message: 'Successful login, redirecting·······',
					             type: 'success'
					           })
						clearInterval(timer)
					 } else {
					   console.log("err0", err)
					 }
				 }).catch(err => {
				 console.log("err", err)
				})
	  });
	} else {
	  console.log("Login failure");
	}	
		}
	}

};
</script>


